const ErrorPopup = ({ error, setError }) => {
  return (
    <div
      className={
        error?.trim()
          ? "modal fade effect-slide-in-bottom show bg-success-transparent"
          : "modal fade effect-slide-in-bottom"
      }
      style={error?.trim() ? { display: "block" } : {}}
    >
      <div
        className="modal-dialog modal-dialog-centered text-center modal-sm"
        role="document"
      >
        <div className="modal-content text-center modal-content-demo">
          <div className="modal-header text-center">
            <h6 className="modal-title text-center mx-auto">Alert</h6>
          </div>
          <div className="modal-body">
            <div className="text-center">
              <p className="text-danger">{error?.trim()}</p>
            </div>
          </div>
          <div className="modal-footer">
            <div className="w-100 d-flex justify-content-center gap-2">
              <button
                onClick={() => {
                  setError(null);
                }}
                className="btn btn-danger"
                type="button"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPopup;
